export const translate = {
  writerwoman: {
    de: 'Schriftstellerin',
    es: 'Escritora',
    fr: 'Rédactrice',
    en: 'Writer',
  },
  writerman: {
    de: 'Schriftsteller',
    es: 'Escritor',
    fr: 'Rédacteur',
    en: 'Writer',
  },
  format: {
    de: 'Format',
    es: 'Formato',
    fr: 'Format',
    en: 'Format',
  },
  date: {
    de: 'Erscheinungsdatum',
    es: 'Fecha de publicación',
    fr: "Date d'édition",
    en: 'Publishing date',
  },
};
